/**
 * Enum centralizzato per i tipi di equipment.
 * Questo è l'unico punto di riferimento per i valori dei tipi di equipment.
 */

export enum EquipmentType {
  Congelatore = 'CONGELATORE',
  Frigorifero = 'FRIGORIFERO',
  Friggitrice = 'FRIGGITRICE',
  MantenimentoCaldo = 'MANTENIMENTO_CALDO',
}

/**
 * Tipi di equipment che richiedono controllo temperatura (HACCP)
 */
export const TEMPERATURE_CONTROLLED_TYPES: EquipmentType[] = [
  EquipmentType.Frigorifero,
  EquipmentType.Congelatore,
  EquipmentType.MantenimentoCaldo,
];

/**
 * Tipi di equipment che richiedono controllo olio
 */
const OIL_CONTROLLED_TYPES: EquipmentType[] = [EquipmentType.Friggitrice];

/**
 * Verifica se un tipo di equipment richiede controllo temperatura
 */
export function requiresTemperatureControl(type: string): boolean {
  return TEMPERATURE_CONTROLLED_TYPES.includes(type as EquipmentType);
}

/**
 * Verifica se un tipo di equipment richiede controllo olio
 */
export function requiresOilControl(type: string): boolean {
  return OIL_CONTROLLED_TYPES.includes(type as EquipmentType);
}

/**
 * Verifica se un tipo di equipment richiede configurazione di controlli
 */
export function requiresChecksConfig(type: string): boolean {
  return requiresTemperatureControl(type) || requiresOilControl(type);
}
